













































import { Component, Vue } from 'vue-property-decorator'
import Moment from 'moment'
import { Apis, Factories } from '@finx/web-repository'
import { Loading, RecebimentoItem } from '@/types/_'
import RecebimentoVuex from '@/store/RecebimentoVuex'

@Component

export default class ViewRecebimentoDetalhe extends Vue {
  items: RecebimentoItem[] = []
  loading: Loading = {
    status: false,
    text: 'Carregando...',
  }

  get fontePagadora() {
    return RecebimentoVuex.getters.FONTE_PAGADORA_SELECTED
  }

  get getItems() {
    return this.items
  }

  set getItems(value) {
    this.items = value
  }

  formatarData(data) {
    return Moment(data).format('DD/MM/YY')
  }

  async getRecebimentoItems() {
    this.loading.status = true
    const contratoId = this.$route.params.contratoId as string
    const dataRecebimento = this.$route.params.data as string

    const request = await Apis.Legacy.Recebimento.getRecebimentoItemsV2(contratoId, dataRecebimento)
    const success = Factories.Apis.success(request)

    if (success && request.data !== '') {
      this.items = request.data
    }

    this.loading.status = false
  }

  async mounted() {
    await this.getRecebimentoItems()
  }
}
